// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__jC8nN","search":"Search_search__Wncrn","searchButton":"Search_searchButton__8Jp1t"};